import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type MarginRejectionReason = 'USER_TIER' | 'REGION_BLOCKED' | 'USER_BLOCKED' | 'MARGIN_UNAVAILABLE'

export type MarginMetadata = {
  marginEligible: boolean
  marginRejectionReason?: MarginRejectionReason
  signedMarginUserAgreement: boolean
}

export type MarginState = MarginMetadata & {
  sign: {
    fetching: boolean
    hasError: boolean
  }
}

const initialState: MarginState = {
  marginEligible: false,
  sign: {
    fetching: false,
    hasError: false
  },
  signedMarginUserAgreement: false
}

const marginSlice = createSlice({
  initialState,
  name: 'margin',
  reducers: {
    setMarginMetadata(state, action: PayloadAction<MarginMetadata>) {
      state.marginEligible = action.payload.marginEligible
      state.marginRejectionReason = action.payload.marginRejectionReason
      state.signedMarginUserAgreement = action.payload.signedMarginUserAgreement
    },
    sign(state) {
      state.sign.fetching = true
      state.sign.hasError = false
    },
    signError(state) {
      state.sign.fetching = false
      state.sign.hasError = true
    },
    signed(state) {
      state.sign.fetching = false
      state.sign.hasError = false
      state.signedMarginUserAgreement = true
    }
  }
})

export const { actions } = marginSlice
export default marginSlice.reducer
